import { useState, useEffect } from 'react';
import useScrollPosition from 'hooks/useScrollPosition';
import useScrollDirection from 'hooks/useScrollDirection';

const toggleStickyheader = (ref, toggleDisplaySimpleHeader) => {
  const [isStickyWithHeader, setStickyWithHeader] = useState(false);
  const [isStickyWithoutHeader, setStickyWithoutHeader] = useState(false);
  const [scrollUp, setScrollUp] = useState(false);
  const [prevYPos, setPrevYPos] = useState(0);
  const scrollDirection = useScrollDirection({ thresholdPixels: 0 });

  useScrollPosition(
    ({ currPos }) => {
      const subNavRef = ref?.current;
      if (subNavRef && document.body.style.position !== 'fixed') {
        if (window.pageYOffset < subNavRef.offsetTop) {
          setStickyWithoutHeader(false);
          setStickyWithHeader(false);
        } else if (scrollDirection === 'down' && Math.abs(currPos.y) >= subNavRef.offsetTop) {
          setStickyWithoutHeader(true);
          setStickyWithHeader(false);
          toggleDisplaySimpleHeader(true);
        } else if (scrollDirection === 'up') {
          if (!scrollUp) setPrevYPos(currPos.y);
          toggleDisplaySimpleHeader(true);
          if (window.pageYOffset < 10) {
            setStickyWithHeader(true);
          }
          if (Math.abs(currPos.y) < Math.abs(prevYPos) - 400) {
            setStickyWithHeader(true);
            setStickyWithoutHeader(false);
          }
        }
      }
    },
    [scrollDirection, prevYPos],
    null,
    false,
    0
  );

  useEffect(() => {
    if (scrollDirection === 'up') {
      setScrollUp(true);
    } else {
      setScrollUp(false);
    }
  }, [scrollDirection]);

  return { isStickyWithHeader, isStickyWithoutHeader };
};

export default toggleStickyheader;
